module.exports = __webpack_public_path__ + "static/media/partnership-Light.44a115be.png";